module.exports = __webpack_public_path__ + "bad2a30f9003776d5acf8830bf0fc342.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-15.png
// module id = 2218
// module chunks = 0